// src/home/Chatbot/chat.reducer.js
import { chatConstants } from "./chat.constants";
import { getBaseUrl, getActivePartnerBasedOnDomain } from "home/DomainName/DomainConstants";

const _partner = getActivePartnerBasedOnDomain();
const _partnerName = _partner.name;
const _productName = _partner.productName;

function sanitizePartnerText(text) {
  if (!text || typeof text !== "string") return text;
  let out = text.replace(/Petasense/gi, _partnerName);
  out = out.replace(/\bARO\b/g, _productName);
  return out;
}

function normalizeCitationEntry(raw) {
  if (raw == null) return null;
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return null;
    return {
      displayLabel: s.split(/[/\\]/).pop() || s,
      document_version_id: null,
      source_download_url: null,
    };
  }
  if (typeof raw === "object") {
    const idRaw = raw.document_version_id != null ? raw.document_version_id : raw.documentVersionId;
    const idStr = idRaw != null && String(idRaw).trim() ? String(idRaw).trim() : null;
    const pathStr = raw.path != null ? String(raw.path) : "";
    const urlRaw =
      raw.source_download_url != null ? raw.source_download_url : raw.sourceDownloadUrl;
    const pathRaw =
      raw.source_download_path != null ? String(raw.source_download_path).trim() : "";
    const downloadUrl =
      (urlRaw != null && String(urlRaw).trim())
        ? String(urlRaw).trim()
        : pathRaw.startsWith("/chatbot/sources/")
          ? getBaseUrl() + "/i/v1" + pathRaw
          : null;
    const label =
      (raw.source != null && String(raw.source)) ||
      (raw.filename != null && String(raw.filename)) ||
      (raw.title != null && String(raw.title)) ||
      (raw.name != null && String(raw.name)) ||
      (pathStr && pathStr.split(/[/\\]/).pop()) ||
      null;
    return {
      displayLabel: label,
      ...(!label && { displayLabelKey: 'chatbot.sources.defaultSource' }),
      document_version_id: idStr,
      source_download_url: downloadUrl,
    };
  }
  return null;
}

function normalizeAndDedupeSources(sources) {
  if (!Array.isArray(sources)) return [];
  const seenIds = new Set();
  const seenUrls = new Set();
  const out = [];
  for (const raw of sources) {
    const entry = normalizeCitationEntry(raw);
    if (!entry) continue;
    if (entry.document_version_id) {
      if (seenIds.has(entry.document_version_id)) continue;
      seenIds.add(entry.document_version_id);
    } else if (entry.source_download_url) {
      if (seenUrls.has(entry.source_download_url)) continue;
      seenUrls.add(entry.source_download_url);
    }
    out.push(entry);
  }
  return out;
}

function collectCitationRawList(data) {
  const list = [];
  if (data && Array.isArray(data.citations)) {
    list.push(...data.citations);
  }
  if (data && Array.isArray(data.sources)) {
    list.push(...data.sources);
  }
  return list;
}

const initialState = {
  messages: [
    {
      role: "bot",
      textKey: 'chatbot.initialGreeting',
      textValues: {
        partnerName: _partnerName,
      },
      timestamp: 0,
    },
  ],
  loading: false,
  error: null,
};

export function chat(state = initialState, action) {
  switch (action.type) {
    // User sent a message
    case chatConstants.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        messages: [
          ...state.messages,
          {
            role: "user",
            text: action.text,
            timestamp: Date.now(),
          },
        ],
      };

    // Backend replied successfully
    case chatConstants.SEND_MESSAGE_SUCCESS: {
      const data = action.data;
      const botText = sanitizePartnerText((data && (data.answer || data.response)) || "");
      return {
        ...state,
        loading: false,
        messages: [
          ...state.messages,
          {
            role: "bot",
            text: botText,
            timestamp: Date.now(),
            sources: normalizeAndDedupeSources(collectCitationRawList(data)),
            confidence: data && data.confidence,
            figure: data && data.figure,
            imageUrl: data && data.image_url,
          },
        ],
      };
    }

    // Backend / network error
    case chatConstants.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        messages: [
          ...state.messages,
          {
            role: "bot",
            textKey: 'chatbot.errors.sendFailed',
            textValues: {
              error: action.error,
            },
            timestamp: Date.now(),
          },
        ],
      };

    // Optional: Clear chat history
    case chatConstants.CLEAR_CHAT:
      return {
        ...state,
        messages: initialState.messages,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
}
